import { useMoment } from '@/shared/composition/useMoment';
import { BitrixEmailTriesResponse } from '@/app/modules/bitrix/BitrixEmailService';

const moment = useMoment();

export const fixtures: Record<string, any> = {
  '/api/user/confirmEmail/status': (): BitrixEmailTriesResponse => {
    const hours = Math.floor(Math.random() * 5);
    const hoursDiff = Math.floor(Math.random() * 7);
    return {
      current_attempts: Math.floor(Math.random() * 7),
      total_attempts: 5,
      is_client_email_confirmed: false,
      time_limit: 86400,
      deadline: moment().add(hours - hoursDiff, 'hours')
        .format('YYYY-MM-DD HH:mm:ss'),
    };
  },
  '/api/user/update': () => ({
    email: 'new',
  }),
  '/api/user/confirmCode': () => ({
    sended: true,
  }),
  '/api/user/confirmEmail': () => ({
    confirmed: false,
  }),
  '/api/change_email_clear': () => ({
    cleared: Math.floor(Math.random() * 5) > 3,
  }),
};
